export const assessmentConstants = {

    USER_ASSESSMENT_USER_PROFILE_REQUEST: 'USER_ASSESSMENT_USER_PROFILE_REQUEST',
    USER_ASSESSMENT_USER_PROFILE_SUCCESS: 'USER_ASSESSMENT_USER_PROFILE_SUCCESS',
    USER_ASSESSMENT_USER_PROFILE_FAILURE: 'USER_ASSESSMENT_USER_PROFILE_FAILURE',

    USER_ASSESSMENT_PACKAGE_BUY_REQUEST: 'USER_ASSESSMENT_PACKAGE_BUY_REQUEST',
    USER_ASSESSMENT_PACKAGE_BUY_SUCCESS: 'USER_ASSESSMENT_PACKAGE_BUY_SUCCESS',
    USER_ASSESSMENT_PACKAGE_BUY_FAILURE: 'USER_ASSESSMENT_PACKAGE_BUY_FAILURE',

    USER_ASSESSMENT_PACKAGE_ORDERS_REQUEST: 'USER_ASSESSMENT_PACKAGE_ORDERS_REQUEST',
    USER_ASSESSMENT_PACKAGE_ORDERS_SUCCESS: 'USER_ASSESSMENT_PACKAGE_ORDERS_SUCCESS',
    USER_ASSESSMENT_PACKAGE_ORDERS_FAILURE: 'USER_ASSESSMENT_PACKAGE_ORDERS_FAILURE',

    USER_ASSESSMENT_SURVEY_LOGIN_REQUEST: 'USER_ASSESSMENT_SURVEY_LOGIN_REQUEST',
    USER_ASSESSMENT_SURVEY_LOGIN_SUCCESS: 'USER_ASSESSMENT_SURVEY_LOGIN_SUCCESS',
    USER_ASSESSMENT_SURVEY_LOGIN_FAILURE: 'USER_ASSESSMENT_SURVEY_LOGIN_FAILURE',

    USER_ASSESSMENT_SURVEY_LOGIN_BY_OTP_REQUEST: 'USER_ASSESSMENT_SURVEY_LOGIN_BY_OTP_REQUEST',
    USER_ASSESSMENT_SURVEY_LOGIN_BY_OTP_SUCCESS: 'USER_ASSESSMENT_SURVEY_LOGIN_BY_OTP_SUCCESS',
    USER_ASSESSMENT_SURVEY_LOGIN_BY_OTP_FAILURE: 'USER_ASSESSMENT_SURVEY_LOGIN_BY_OTP_FAILURE',

    GET_ASSESSMENT_PACKAGE_LIST_REQUEST: 'GET_ASSESSMENT_PACKAGE_LIST_REQUEST',
    GET_ASSESSMENT_PACKAGE_LIST_SUCCESS: 'GET_ASSESSMENT_PACKAGE_LIST_SUCCESS',
    GET_ASSESSMENT_PACKAGE_LIST_FAILURE: 'GET_ASSESSMENT_PACKAGE_LIST_FAILURE',

    GET_ASSESSMENT_PACKAGE_BY_ID_REQUEST: 'GET_ASSESSMENT_PACKAGE_BY_ID_REQUEST',
    GET_ASSESSMENT_PACKAGE_BY_ID_SUCCESS: 'GET_ASSESSMENT_PACKAGE_BY_ID_SUCCESS',
    GET_ASSESSMENT_PACKAGE_BY_ID_FAILURE: 'GET_ASSESSMENT_PACKAGE_BY_ID_FAILURE',


    ASSESSMENT_ADD_TO_CART_REQUEST: 'ASSESSMENT_ADD_TO_CART_REQUEST',
    ASSESSMENT_ADD_TO_CART_SUCCESS: 'ASSESSMENT_ADD_TO_CART_SUCCESS',
    ASSESSMENT_ADD_TO_CART_FAILURE: 'ASSESSMENT_ADD_TO_CART_FAILURE',


    GET_ASSESSMENT_CART_ITEMS_REQUEST: 'GET_ASSESSMENT_CART_ITEMS_REQUEST',
    GET_ASSESSMENT_CART_ITEMS_SUCCESS: 'GET_ASSESSMENT_CART_ITEMS_SUCCESS',
    GET_ASSESSMENT_CART_ITEMS_FAILURE: 'GET_ASSESSMENT_CART_ITEMS_FAILURE',

    UPDATE_ASSESSMENT_CART_ITEMS_REQUEST: 'UPDATE_ASSESSMENT_CART_ITEMS_REQUEST',
    UPDATE_ASSESSMENT_CART_ITEMS_SUCCESS: 'UPDATE_ASSESSMENT_CART_ITEMS_SUCCESS',
    UPDATE_ASSESSMENT_CART_ITEMS_FAILURE: 'UPDATE_ASSESSMENT_CART_ITEMS_FAILURE',


    GET_ASSESSMENT_CART_PRICE_TOTAL_REQUEST: 'GET_ASSESSMENT_CART_PRICE_TOTAL_REQUEST',
    GET_ASSESSMENT_CART_PRICE_TOTAL_SUCCESS: 'GET_ASSESSMENT_CART_PRICE_TOTAL_SUCCESS',
    GET_ASSESSMENT_CART_PRICE_TOTAL_FAILURE: 'GET_ASSESSMENT_CART_PRICE_TOTAL_FAILURE',

    DELETE_ASSESSMENT_CART_ITEM_REQUEST: 'DELETE_ASSESSMENT_CART_ITEM_REQUEST',
    DELETE_ASSESSMENT_CART_ITEM_SUCCESS: 'DELETE_ASSESSMENT_CART_ITEM_SUCCESS',
    DELETE_ASSESSMENT_CART_ITEM_FAILURE: 'DELETE_ASSESSMENT_CART_ITEM_FAILURE',


    GET_ORDER_BOOK_LIST_REQUEST: 'GET_ORDER_BOOK_LIST_REQUEST',
    GET_ORDER_BOOK_LIST_SUCCESS: 'GET_ORDER_BOOK_LIST_SUCCESS',
    GET_ORDER_BOOK_LIST_FAILURE: 'GET_ORDER_BOOK_LIST_FAILURE',

    USER_ASSESSMENT_RESPONSE_ANALYTICS_REQUEST: 'USER_ASSESSMENT_RESPONSE_ANALYTICS_REQUEST',
    USER_ASSESSMENT_RESPONSE_ANALYTICS_SUCCESS: 'USER_ASSESSMENT_RESPONSE_ANALYTICS_SUCCESS',
    USER_ASSESSMENT_RESPONSE_ANALYTICS_FAILURE: 'USER_ASSESSMENT_RESPONSE_ANALYTICS_FAILURE',

    USER_ASSESSMENT_ORDER_NAME_UPDATE_REQUEST: 'USER_ASSESSMENT_ORDER_NAME_UPDATE_REQUEST',
    USER_ASSESSMENT_ORDER_NAME_UPDATE_SUCCESS: 'USER_ASSESSMENT_ORDER_NAME_UPDATE_SUCCESS',
    USER_ASSESSMENT_ORDER_NAME_UPDATE_FAILURE: 'USER_ASSESSMENT_ORDER_NAME_UPDATE_FAILURE',

    GET_ASSESSMENT_CART_COUNT_REQUEST: 'GET_ASSESSMENT_CART_COUNT_REQUEST',
    GET_ASSESSMENT_CART_COUNT_SUCCESS: 'GET_ASSESSMENT_CART_COUNT_SUCCESS',
    GET_ASSESSMENT_CART_COUNT_FAILURE: 'GET_ASSESSMENT_CART_COUNT_FAILURE',

    SAVE_ASSESSMENT_CONTACT_US_REQUEST: 'SAVE_ASSESSMENT_CONTACT_US_REQUEST',
    SAVE_ASSESSMENT_CONTACT_US_SUCCESS: 'SAVE_ASSESSMENT_CONTACT_US_SUCCESS',
    SAVE_ASSESSMENT_CONTACT_US_FAILURE: 'SAVE_ASSESSMENT_CONTACT_US_FAILURE',

    UPDATE_ASSESSMENT_USER_PROFILE_REQUEST: 'UPDATE_ASSESSMENT_USER_PROFILE_REQUEST',
    UPDATE_ASSESSMENT_USER_PROFILE_SUCCESS: 'UPDATE_ASSESSMENT_USER_PROFILE_SUCCESS',
    UPDATE_ASSESSMENT_USER_PROFILE_FAILURE: 'UPDATE_ASSESSMENT_USER_PROFILE_FAILURE',


    ASSESSMENT_DOWNLOAD_STATUS_REQUEST: 'ASSESSMENT_DOWNLOAD_STATUS_REQUEST',
    ASSESSMENT_DOWNLOAD_STATUS_SUCCESS: 'ASSESSMENT_DOWNLOAD_STATUS_SUCCESS',
    ASSESSMENT_DOWNLOAD_STATUS_FAILURE: 'ASSESSMENT_DOWNLOAD_STATUS_FAILURE',

    GET_USER_ASSESSMENT_LANG_REQUEST: 'GET_USER_ASSESSMENT_LANG_REQUEST',
    GET_USER_ASSESSMENT_LANG_SUCCESS: 'GET_USER_ASSESSMENT_LANG_SUCCESS',
    GET_USER_ASSESSMENT_LANG_FAILURE: 'GET_USER_ASSESSMENT_LANG_FAILURE',

    ASSESSMENT_DOWNLOAD_SHORT_PRODUCT_LIST_REQUEST: 'ASSESSMENT_DOWNLOAD_SHORT_PRODUCT_LIST_REQUEST',
    ASSESSMENT_DOWNLOAD_SHORT_PRODUCT_LIST_SUCCESS: 'ASSESSMENT_DOWNLOAD_SHORT_PRODUCT_LIST_SUCCESS',
    ASSESSMENT_DOWNLOAD_SHORT_PRODUCT_LIST_FAILURE: 'ASSESSMENT_DOWNLOAD_SHORT_PRODUCT_LIST_FAILURE',
};


